import React from 'react';
import { ThemeProvider } from 'styled-components';
import styled from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import { darkTheme, lightTheme } from './styles/theme';
import { ThemeModeProvider, useThemeMode } from './context/ThemeContext';
import { SEOProvider, SEO } from './components/common/SEO';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Education from './components/Education/Education';
import Experience from './components/Experience/Experience';
import Achievements from './components/Achievements/Achievements';
import Certifications from './components/Certifications/Certifications';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import MaintenanceMode from './components/MaintenanceMode/MaintenanceMode';
import Sidebar from './components/Layout/Sidebar';

const TwoCol = styled.div`
  display: flex;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 40px;

  @media (max-width: 1080px) {
    display: block;
    padding: 0;
  }
`;

const ContentCol = styled.main`
  flex: 1;
  min-width: 0;
`;

const AppInner: React.FC = () => {
  const { mode } = useThemeMode();
  const currentTheme = mode === 'dark' ? darkTheme : lightTheme;
  const isMaintenanceMode =
    process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  return (
    <ThemeProvider theme={currentTheme}>
      <GlobalStyles />
      {isMaintenanceMode ? (
        <MaintenanceMode />
      ) : (
        <SEOProvider>
          <SEO />
          <Hero />
          <TwoCol>
            <Sidebar />
            <ContentCol>
              <About />
              <Experience />
              <Education />
              <Achievements />
              <Certifications />
              <Contact />
              <Footer />
            </ContentCol>
          </TwoCol>
        </SEOProvider>
      )}
    </ThemeProvider>
  );
};

function App() {
  return (
    <ThemeModeProvider>
      <AppInner />
    </ThemeModeProvider>
  );
}

export default App;
